export default function ({ store, redirect, localePath }) {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  if (isAuthenticated) {
    return redirect(localePath("/"));
  }
}
